import { render, staticRenderFns } from "./RoleSelection.modal.vue?vue&type=template&id=259517de&scoped=true"
import script from "./RoleSelection.modal.vue?vue&type=script&lang=ts"
export * from "./RoleSelection.modal.vue?vue&type=script&lang=ts"
import style0 from "./RoleSelection.modal.vue?vue&type=style&index=0&id=259517de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259517de",
  null
  
)

export default component.exports